import styled from 'styled-components';
import { Divider, Flex, Text } from '@bancobarigui/barihaus';

export const ModalContentWrapper = styled(Flex)`
  width: 100%;
`;

export const ModalDivider = styled(Divider)`
  margin-top: 8px;
`;

export const ModalDescription = styled(Text)`
  width: 100%;
  text-align: center;
`;
